import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../core/auth.service';
import { Router } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import { AppInformationService } from 'app/core/core.module';
import { first } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
    model = { userName: '', password: '' };

    constructor(private auth: AuthService, private router: Router, private appInfo: AppInformationService) {}

    ngOnInit() {
        this.auth.logout();
    }

    async login() {

        // await this.login();
        await this.appInfo.pleaseWaitShow();

        this.auth
            .login(this.model.userName, this.model.password)
            .pipe(first())
            .subscribe({
                next: async () => {
                    try {
                        if (this.auth.currentUser) {
                            this.router.navigate(['/']);
                            this.appInfo.pleaseWaitHide();
                            return;
                        }
                        this.appInfo.pleaseWaitHide();
                        alert('Error logging into server', 'Login Error');
                    } catch (exception) {
                        const ex: any = exception;
                        this.appInfo.pleaseWaitHide();
                        console.log(ex);
                        await alert((exception && (ex.error.error_description || ex.message)) || 'Error logging into server', 'Login Error');
                    } finally {
                        this.appInfo.pleaseWaitHide();
                    }
                },
                error: async (exception) => {
                    await alert(exception || 'Error logging into server', 'Login Error');
                    this.appInfo.pleaseWaitHide();
                },
            });
    }

    // async login() {
    //     try {
    //         const user = await this.auth.login(this.model.userName, this.model.password);
    //         if (user) {
    //             this.router.navigate(['/']);
    //             return;
    //         }
    //         this.appInfo.pleaseWait = false;
    //         alert('Error logging into server', 'Login Error');
    //     } catch (exception) {
    //         console.error(exception);
    //         alert((exception && (exception.error.error_description || exception.message)) || 'Error logging into server', 'Login Error');
    //     }
    // }
}
